export const ADMIN_MAIL = 'admin@bd-kol.com'
export const SUPER_MAIL = 'super@bd-kol.com'
export const USER_MAIL = 'user@bd-kol.com'

export const isUserAdmin = email => {
  return email === ADMIN_MAIL || email === SUPER_MAIL
}

export const isUserSuper = email => {
  return email === SUPER_MAIL
}
